import { create } from "zustand";

type Connection = {
  email: string;
  settings: {
    enables: {
      email_sending: boolean;
      email_receiving: boolean;
    };
  };
};

type ReplyTo = {
  body: string;
  subject: string;
  messageId: string;
  threadId: string;
  originalSender: string;
  originalDate: string;
  replyToEmail?: string; // Email to reply to
};

interface NewEmail {
  open: boolean;
  setOpen: (open: boolean, replyTo?: ReplyTo) => void;
  replyTo: ReplyTo | null;
  myMails: string[];
  setMyMails: (myMails: string[]) => void;
  sendingTo: string | null;
  setSendingTo: (sendingTo: string | null) => void;
  connections: Connection[];
  setConnections: (enables: Connection[]) => void;
  leadId: number | null;
  setLeadId: (leadId: number | null) => void;
}

export const useNewEmailStore = create<NewEmail>((set) => ({
  open: false,
  setOpen: (open, replyTo) => set({ open, replyTo }),
  myMails: [],
  setMyMails: (myMails) => set({ myMails }),
  sendingTo: null,
  replyTo: null,
  setSendingTo: (sendingTo) => set({ sendingTo }),
  connections: [],
  setConnections: (connections) => set({ connections }),
  leadId: null,
  setLeadId: (leadId) => set({ leadId }),
}));
